module.exports = __webpack_public_path__ + "static/img/solution5.c94c0ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/solution5.png
// module id = Didy
// module chunks = 1